module.exports = __webpack_public_path__ + "img/sad.75ef5336.png";